import { useContext, useCallback, useMemo } from "react";
import { Marker } from "@react-google-maps/api";
import { FindAStoreContext } from "../contexts/findAStore";
import { getActiveIcon, getDefaultIcon } from "../utils/markerIcons";

const Markers = () => {
  const {
    state: { stores, activeStore },
    dispatch,
  } = useContext(FindAStoreContext);
  const setActiveStore = (storeId: number | undefined) =>
    dispatch({ type: "SetActiveStore", payload: storeId });

  const google = typeof window !== "undefined" ? window.google : (null as any);

  const activeStoreData = stores.find((store) => store.id == activeStore);
  // const activeIconRaw = getActiveIcon(activeStoreData);
  // const defaultIconRaw = getDefaultIcon(activeStoreData);

  // const activeIcon = {
  //   url: activeIconRaw.url,
  //   scaledSize: new google.maps.Size(
  //     activeIconRaw.scaledSize[0],
  //     activeIconRaw.scaledSize[1]
  //   ),
  // };
  // const defaultIcon = {
  //   url: defaultIconRaw.url,
  //   anchor: new google.maps.Point(
  //     defaultIconRaw.anchor[0],
  //     defaultIconRaw.anchor[1]
  //   ),
  //   scaledSize: new google.maps.Size(
  //     defaultIconRaw.scaledSize[0],
  //     defaultIconRaw.scaledSize[1]
  //   ),
  // };

  const onMarkerClick = useCallback(
    (key: number) => {
      if (activeStore !== key) {
        setActiveStore(key);
      }
    },
    [activeStore]
  );
  return useMemo(() => {
    return (
      <div>
        {stores?.map((store) => (
          <Marker
            position={
              new google.maps.LatLng(
                store.gPS?.split(",")[0],
                store.gPS?.split(",")[1]
              )
            }
            //Add cashless logo here
            icon={
              store.id == activeStore
                ? store.cashless
                  ? getActiveIcon(store)
                  : getActiveIcon(store)
                : store.cashless
                ? getDefaultIcon(store)
                : getDefaultIcon(store)
            }
            key={store.id}
            options={{
              optimized: true,
            }}
            onClick={() => onMarkerClick(store.id)}
          />
        ))}
      </div>
    );
  }, [activeStore, stores]);
};

export default Markers;
